import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import apiClient from '@services/api/client'
import toast from 'react-hot-toast'

function PaymentSuccessPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const postId   = searchParams.get('postId')
  const duration = parseInt(searchParams.get('duration') || '7')
  const [confirmed, setConfirmed] = useState(false)

  useEffect(() => {
    const confirm = async () => {
      if (!postId) {
        setConfirmed(true)
        return
      }
      try {
        await apiClient.post('/payment/confirm', { post_id: postId, duration })
        setConfirmed(true)
        toast.success('Publication activée avec succès !')
      } catch {
        setConfirmed(true)
      }
    }
    confirm()
  }, [postId, duration])

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-[#001F3F] mb-3">Paiement réussi !</h1>
        <p className="text-gray-600 mb-2">Votre paiement Wave a été confirmé.</p>
        <p className="text-gray-500 text-sm mb-8">
          Votre publication sera active sous quelques instants.
        </p>
        <div className="space-y-3">
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full py-3 bg-gradient-to-r from-[#D4AF37] to-[#C49B2E] text-white font-bold rounded-xl hover:shadow-lg transition-all"
          >
            Voir mon tableau de bord
          </button>
          <button
            onClick={() => navigate('/kudhi-market')}
            className="w-full py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all"
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccessPage
